// Material "format_color_text" and "format_color_fill". The paths sit in a
// `<g>` so the toolbar's `svg > g` fill rules colour them; the bar keeps
// Quill's `ql-color-label` class so the picker paints the selected colour on it.
const colorIcon = (path: string) => `<svg viewBox="0 0 24 24">
  <g>
    <path d="${path}"/>
    <rect class="ql-color-label" x="2" y="20" width="20" height="4"/>
  </g>
</svg>`;

export const textColorIcon = colorIcon(
  "M5.49 17h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61l2.03-5.79h.12l2.03 5.79H9.91z"
);

export const backgroundColorIcon = colorIcon(
  "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
);
